// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".XltYGJTdrDvBEEYpbq1K{height:150px}", "",{"version":3,"sources":["webpack://./src/dance/ai/ai-block-preview.module.scss"],"names":[],"mappings":"AAAA,sBACE,YAAA","sourcesContent":[".container {\n  height: 150px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "XltYGJTdrDvBEEYpbq1K"
};
export default ___CSS_LOADER_EXPORT___;
